import React from 'react';

/**
 * 9.7: Global responsive breakpoints injected via <style> tag.
 * Uses CSS media queries to adjust the app layout on small screens.
 * This approach complements the inline JS styles used throughout the app.
 */
export default function ResponsiveStyles() {
  return (
    <style>{`
      /* ── Mobile breakpoint: < 768px ─────────────────────────────── */
      @media (max-width: 767px) {
        /* Forms: full-width inputs on mobile */
        input[type="text"],
        input[type="number"],
        input[type="password"],
        input[type="email"],
        input[type="tel"],
        input[type="search"],
        textarea,
        select {
          max-width: 100% !important;
          box-sizing: border-box !important;
        }

        /* Tables: ensure scroll wrapper is visible */
        table {
          min-width: 500px;
        }

        /* Settings page: stack setting rows vertically */
        [data-settings-row] {
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 8px !important;
        }

        /* Reduce padding on small screens */
        [data-page-container] {
          padding-left: 10px !important;
          padding-right: 10px !important;
        }
      }

      /* ── Small mobile: < 480px ──────────────────────────────────── */
      @media (max-width: 479px) {
        /* Header: hide org name text on very small screens */
        [data-header-title] {
          display: none !important;
        }

        /* Compact filter bars */
        [data-filter-bar] {
          gap: 4px !important;
        }
        [data-filter-bar] select {
          font-size: 11px !important;
          padding: 4px 6px !important;
        }
      }

      /* ── Tablet / Desktop: >= 768px ─────────────────────────────── */
      @media (min-width: 768px) {
        /* Slightly wider containers on tablets */
        [data-page-container] {
          padding-left: 20px !important;
          padding-right: 20px !important;
        }
      }
    `}</style>
  );
}
